var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerRequirementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 14.6667C1.20833 14.6667 0.816111 14.5036 0.49 14.1775C0.163333 13.8508 0 13.4583 0 13H3.33333C2.875 13 2.48278 12.8369 2.15667 12.5108C1.83 12.1842 1.66667 11.7917 1.66667 11.3333V2.16667C1.66667 1.70833 1.83 1.31583 2.15667 0.989167C2.48278 0.663055 2.875 0.5 3.33333 0.5H16.6667C17.125 0.5 17.5175 0.663055 17.8442 0.989167C18.1703 1.31583 18.3333 1.70833 18.3333 2.16667V11.3333C18.3333 11.7917 18.1703 12.1842 17.8442 12.5108C17.5175 12.8369 17.125 13 16.6667 13H20C20 13.4583 19.8369 13.8508 19.5108 14.1775C19.1842 14.5036 18.7917 14.6667 18.3333 14.6667H1.66667ZM10 13.8333C10.2361 13.8333 10.4342 13.7533 10.5942 13.5933C10.7536 13.4339 10.8333 13.2361 10.8333 13C10.8333 12.7639 10.7536 12.5661 10.5942 12.4067C10.4342 12.2467 10.2361 12.1667 10 12.1667C9.76389 12.1667 9.56611 12.2467 9.40667 12.4067C9.24667 12.5661 9.16667 12.7639 9.16667 13C9.16667 13.2361 9.24667 13.4339 9.40667 13.5933C9.56611 13.7533 9.76389 13.8333 10 13.8333ZM3.33333 11.3333H16.6667V2.16667H3.33333V11.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerRequirementsIcon);
export default __webpack_public_path__ + "static/media/computer-requirements--icon.985be113df62cfd8dad104a02dd6d80e.svg";
export { ForwardRef as ReactComponent };